<template>
  <div class="pagination">
    <ul class="pagination__list">
      <li class="pagination__list__item" v-for="(item, index) in items" :key="index">
        <m4-button
          v-if="item.active"
          @click="(e) => click(e, item)"
          tag="a"
          variant="info"
          :href="item.url"
          :class="itemClasses(item)"
        >
          {{ item.title }}
        </m4-button>
        <m4-button
          v-else
          @click="(e) => click(e, item)"
          tag="a"
          variant="info-link"
          :href="item.url"
          :class="itemClasses(item)"
        >
          {{ item.title }}
        </m4-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "M4Pagination",
  props: {
    items: Array,
    ajaxPagination: Boolean
  },
  emits: ["click"],
  methods: {
    itemClasses(item) {
      let classes = [];
      if (!item.url || item.url === "") {
        classes.push("disabled");
      }
      if (item.active) {
        classes.push("active");
      }
      return classes;
    },
    click(e, item) {
      if (this.ajaxPagination) {
        e.preventDefault();
        if (item.url) {
          this.$emit("click", item);
        }

        return false;
      }
    }
  }
};
</script>
